export default function transformStringToNumber(value: string) {
  if (!value.length) return '';

  return parseInt(value, 10);
}
